import { Domain } from 'src/app/services/domain.service';

export const AI_ACCESS_SCOPE_ELECTED_ONLY = 'elected_only';
export const AI_ACCESS_SCOPE_ALL_USERS = 'all_users';

export const canUseAiAssistant = (domain: Domain | null | undefined, roles: string[] = []): boolean => {
  if (!domain?.chatbot_ai?.is_activated || !Array.isArray(roles)) {
    return false;
  }

  if (domain.chatbot_ai.access_scope === AI_ACCESS_SCOPE_ALL_USERS) {
    return true;
  }

  // Missing access_scope is treated as elected_only for compatibility with
  // API responses cached before the access-scope migration was deployed.
  return roles.some(role => role !== 'user');
};
